import React from 'react';
import clsx from 'clsx';
import { Icon } from 'semantic-ui-react';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const AnnouncementNav = () => {
  const { count, index } = Selectors.useAnnouncementNav();
  const next = Events.useNextAnnouncement();
  const previous = Events.usePreviousAnnouncement();
  const nextIndex = index < count - 1;
  const previousIndex = index <= count && index > 0;
  const navStyles = 'absolute f-12 top-45 z-1';

  if (count < 2) return null;

  return (
    <>
      <Icon
        name="arrow left"
        size="small"
        className={clsx(navStyles, 'right-15', previousIndex ? 'pointer' : 'dim')}
        onClick={() => (previousIndex ? previous() : null)}
      />
      <Icon
        name="arrow right"
        size="small"
        className={clsx(navStyles, 'right-0', nextIndex ? 'pointer' : 'dim')}
        onClick={() => (nextIndex ? next() : null)}
      />
    </>
  );
};

export default AnnouncementNav;
